import { connect } from 'react-redux';

import { getDateFnsLocaleFromAppLocale } from 'helpers/intl-fns';
import { selectIsDesktop } from 'selectors/ui';
import { selectSchedulesStartDate } from 'selectors/general';
import { selectLocale } from 'selectors/locale-data';
import { updateStartDate } from 'features/YieldManagement/YieldManagement.saga';

import DateControls from './DateControls';

const mapStateToProps = (state, ownProps) => {
  const locale = selectLocale(state);
  const dateFnsLocale = getDateFnsLocaleFromAppLocale(locale);
  // eslint-disable-next-line import/no-dynamic-require
  const dateFnsLocaleFile = require(`date-fns/locale/${dateFnsLocale}/index.js`);

  return {
    ...ownProps,
    isDesktop: selectIsDesktop(state),
    date: ownProps.date || selectSchedulesStartDate(state),
    dateFnsLocale: dateFnsLocaleFile,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  setDate: (...args) => {
    if (ownProps.setDate) {
      ownProps.setDate(...args);
    } else {
      dispatch(updateStartDate(...args));
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DateControls);
